import { mockAbout } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">关于我们</h2>
          <p className="text-sm text-foreground-600 max-w-[500px] mx-auto">
            了解虫虫漫画背后的故事与初心
          </p>
        </div>

        <div className="max-w-[800px] mx-auto">
          <div className="bg-background-50 border border-background-200/70 rounded-lg p-6 md:p-10">
            <div className="flex items-center gap-3 mb-6 justify-center">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-50 text-primary-500">
                <i className="ri-book-open-line text-2xl"></i>
              </div>
              <h3 className="text-xl font-heading text-foreground-900">{mockAbout.title}</h3>
            </div>
            <div className="space-y-4">
              {mockAbout.paragraphs.map((p, i) => (
                <p key={i} className="text-sm text-foreground-600 leading-relaxed">{p}</p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}